import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import Cookies from "js-cookie";
import { RetryOnError, verifyToken } from "../utilities/VerifyToken"
import { checkForAuthorization } from "utilities/index";


export const FetchPermissionsTemplate = () => {
    // console.log(page.page,page.search,"page")
    return useQuery(
        ['master-FetchPermissionsTemplate-template-all-FetchPermissionsTemplate-fetch-all'],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/settings?config_type=startup_permission`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            const permissions = {}
            data.data.data[0]?.config_values?.forEach((item, index) => {
                permissions[item.code] = {
                    label: item.name,
                    actions: item?.actions,
                    _id: item?._id
                }
            });
            return permissions
        },
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const FetchUserAssociatedStartups = () => {
    // console.log(id,"id")
    // console.log(page.page,page.search,"page")
    return useQuery(
        ['FetchUserAssociatedStartups-FetchUserAssociatedStartups-template-for-all-FetchUserAssociatedStartups-FetchUserAssociatedStartups-fetch'],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/startups/get-startup-accounts`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            // console.log(data,'values new')
            return data?.data?.data
        },
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const FetchUserPermissionsForCurrentStartup = ({ startup_id }) => {
    // console.log(id,"id")
    // console.log(page.page,page.search,"page")
    return useQuery(
        ['FetchUserPermissionsForAssociatedStartups-FetchUserPermissionsForAssociatedStartups-template-for-all-FetchUserPermissionsForAssociatedStartups-FetchUserPermissionsForAssociatedStartups-fetch' + startup_id + checkForAuthorization(), startup_id],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/startups/get-user-permission/${startup_id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            // console.log(data,'values new')
            return data?.data?.data
        },
        enabled: !!startup_id,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}